import React from "react";

import "./tabs.css";

function Tabs(props) {
  const { tabTypes, visibleTab, setVisibleTab } = props;

  const tabTitles = tabTypes?.map((item, index) => (
    <li
      key={index}
      onClick={() => setVisibleTab(item.id)}
      className={
        visibleTab === item.id ? "tab-lists tab-lists--active" : "tab-lists"
      }
    >
      {item.tabTitle}
    </li>
  ));

  const tabContent = tabTypes?.map((item, index) => {
    return (
      <div
        key={index}
        className="container"
        style={visibleTab === item.id ? {} : { display: "none" }}
      >
        {item.tabContent}
      </div>
    );
  });

  return (
    <div className="tabs-menu">
      <ul className="tabs-class-ul">{tabTitles}</ul>
      <div className="tab-content">{tabContent}</div>
    </div>
  );
}

export default Tabs;
